module.exports = [[1,"Schlecht"],[2,"Mittel"],[3,"Gut"],[4,"Sehr gut"],[5,"Perfekt"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Scores.json
// module id = 224
// module chunks = 0